// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DebitCardPinResponseModel } from './debitCardPinResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DebitCardGetDebitCardPinDebitCardPinResponse {
    'data': DebitCardPinResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DebitCardGetDebitCardPinDebitCardPinResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "DebitCardPinResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return DebitCardGetDebitCardPinDebitCardPinResponse.attributeTypeMap;
    }
}
